export const MovingBallsLoader = ({
  className,
  ballColor = 'bg-gray-800', // Default Tailwind class for similar color to #2e354b
}: {
  className?: string;
  ballColor?: string;
}) => {
  return (
    <div
      style={{
        width: '4em',
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      className={className}
    >
      <div
        className={ballColor}
        style={{
          width: '0.7em',
          height: '0.7em',
          borderRadius: '50%',
          transform: 'translateX(-100%)',
          animation: 'left-swing 0.5s ease-in alternate infinite',
        }}
      ></div>
      <div
        className={ballColor}
        style={{
          width: '0.7em',
          height: '0.7em',
          borderRadius: '50%',
        }}
      ></div>
      <div
        className={ballColor}
        style={{
          width: '0.7em',
          height: '0.7em',
          borderRadius: '50%',
          transform: 'translateX(-95%)',
          animation: 'right-swing 0.5s ease-out alternate infinite',
        }}
      ></div>
      <style>{`
        @keyframes left-swing {
          50%,
          100% {
            transform: translateX(95%);
          }
        }
        @keyframes right-swing {
          50% {
            transform: translateX(-95%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
};
